import React__default from 'react';
import ChannelSettingsUI from './ChannelSettings/components/ChannelSettingsUI.js';
import { ChannelSettingsProvider } from './ChannelSettings/context.js';
import './useSendbirdStateContext.js';
import './withSendBird.js';
import './_rollupPluginBabelHelpers-8e4fae98.js';
import './index-303a3b6e.js';
import 'prop-types';
import './ui/Icon.js';
import './ui/Loader.js';
import './LocalizationContext-b021af8f.js';
import './stringSet-91746bf1.js';
import './index-353f13f3.js';
import './index-a611bd38.js';
import './ui/IconButton.js';
import './ChannelSettings/components/ChannelProfile.js';
import './ui/ChannelAvatar.js';
import './ui/Avatar.js';
import './tslib.es6-83aa13f5.js';
import './ui/ImageRenderer.js';
import './uuid-6d14d007.js';
import './utils-7d39b941.js';
import './ui/TextButton.js';
import './color-2863fbbe.js';
import './ChannelSettings/components/EditDetailsModal.js';
import './ui/Modal.js';
import 'react-dom';
import './index-1fd114b0.js';
import './index-41a6f4f2.js';
import './utils-9ef11656.js';
import './ui/Input.js';
import './ChannelSettings/components/AdminPanel.js';
import './ui/Accordion.js';
import './ui/AccordionGroup.js';
import './context-7877e5bb.js';
import './ui/Badge.js';
import './ui/ContextMenu.js';
import './index-ad4c9e58.js';
import './ui/SortByRow.js';
import './ChannelSettings/components/UserListItem.js';
import './UserProfileContext-daa99f9b.js';
import './ui/MutedAvatarOverlay.js';
import './ui/UserProfile.js';
import './sendBirdSelectors.js';
import './topics-17d99dd6.js';
import './ui/UserListItem.js';
import './ui/Checkbox.js';
import './MemberList-323e7517.js';
import './ChannelSettings/components/LeaveChannel.js';
import './ChannelSettings/components/UserPanel.js';

var ChannelSettings = function ChannelSettings(props) {
  return /*#__PURE__*/React__default.createElement(ChannelSettingsProvider, {
    channelUrl: props.channelUrl,
    onCloseClick: props === null || props === void 0 ? void 0 : props.onCloseClick,
    onChannelModified: props === null || props === void 0 ? void 0 : props.onChannelModified,
    onBeforeUpdateChannel: props === null || props === void 0 ? void 0 : props.onBeforeUpdateChannel,
    queries: props === null || props === void 0 ? void 0 : props.queries,
    className: props === null || props === void 0 ? void 0 : props.className,
    disableUserProfile: props === null || props === void 0 ? void 0 : props.disableUserProfile,
    renderUserProfile: props === null || props === void 0 ? void 0 : props.renderChannelProfile
  }, /*#__PURE__*/React__default.createElement(ChannelSettingsUI, {
    renderPlaceholderError: props === null || props === void 0 ? void 0 : props.renderPlaceholderError,
    renderChannelProfile: props === null || props === void 0 ? void 0 : props.renderChannelProfile,
    renderModerationPanel: props === null || props === void 0 ? void 0 : props.renderModerationPanel,
    renderLeaveChannel: props === null || props === void 0 ? void 0 : props.renderLeaveChannel
  }));
};

export { ChannelSettings as default };